<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Crear / Editar -->
    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_ocupacion === null ? "Crear" : "Editar" }} Ocupación
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Eliminar -->
    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Ocupación</v-card-title>

        <v-card-text>
          ¿Está seguro de que desea eliminar la ocupación llamada
          "{{ editedItem.nombre }}"? Esta acción es permanente y no se puede revertir.
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón crear -->
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Ocupación
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="openDialogDelete(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";

export default {
  components: {
    VAlertDialog
  },
  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,

    loading: false,
    loadingSave: false,
    loadingDelete: false,

    items: [],
    headers: [
      {
        text: "Ocupación",
        value: "nombre",
        align: "center",
        width: "90%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%"
      }
    ],

    editedItem: {
      id_ocupacion: null,
      nombre: ""
    },
    defaultEditedItem: {
      id_ocupacion: null,
      nombre: ""
    }
  }),
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      axios
        .get("/Catalogos/ListarOcupaciones")
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al cargar las ocupaciones.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openDialogAddEdit(editItem = null) {
      if (editItem != null) this.editedItem = Object.assign({}, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);

      this.dialogAddEdit = true;
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },

    saveDialogAddEdit() {
      if (
        this.editedItem.nombre == null ||
        this.editedItem.nombre.length === 0 ||
        this.editedItem.nombre.length > 256
      ) {
        this.$refs.alert.setMessage("", "Debe de ingresar un Nombre entre 1 y 256 caracteres");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      const isCreate = this.editedItem.id_ocupacion === null;

      axios({
        method: isCreate ? "POST" : "PUT",
        url: isCreate
          ? "/Catalogos/CrearOcupacion"
          : `/Catalogos/EditarOcupacion/${this.editedItem.id_ocupacion}`,
        data: {
          nombre: this.editedItem.nombre
        }
      })
        .then(() => {
          // CrearOcupacion regresa Guid, pero no es necesario usarlo aquí
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch((error) => {
          if (error?.response?.status === 409) {
            this.$refs.alert.setMessage("", "Ya existe una Ocupación con el mismo Nombre.");
            this.$refs.alert.open();
            return;
          }

          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al guardar la ocupación.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },

    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },

    saveDialogDelete() {
      if (this.editedItem.id_ocupacion == null) return;

      this.loadingDelete = true;
      axios
        .delete(`/Catalogos/EliminarOcupacion/${this.editedItem.id_ocupacion}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch((error) => {
          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al eliminar la ocupación.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    }
  }
};
</script>
